export default __webpack_public_path__ + "static/banner-cdc09a5d9ed4bff4aa5a0c3e70713d38.png";